<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical
        headerTitle="정산조회"
        device="multi"
        contentsClass="overflow-x-hidden overflow-y-auto pr-5"
        :IsUseEditorBox="true"
        :IsUseTopAddition="true"
      >
        <template v-slot:EditorBox>
          <v-row no-gutters>
            <v-col class="d-flex justify-end mr-2">
              <v-btn outlined color="btn_outline" class="outlined-btn" large width="92" @click="getCurrentMonth()">
                <div class="d-flex align-center">
                  <svg-icon icon-class="history" class="btn_text--text" />
                  <span style="font-size: 1rem" class="main_text--text">금월</span>
                </div>
              </v-btn>
            </v-col>
            <v-col>
              <i-date-time-picker
                :key="searchStartDate"
                :firstDisplayDate="startDate"
                placeholder="시작일자"
                :menu="true"
                :month="true"
                :allowMaxDate="searchMaxDate"
                @getDate="setSearchDate($event, 'start')"
              ></i-date-time-picker>
            </v-col>
            <span class="pt-1 mx-1">~</span>
            <v-col>
              <i-date-time-picker
                :key="searchEndDate"
                :firstDisplayDate="endDate"
                placeholder="종료일자"
                :menu="true"
                :month="true"
                :allowMinDate="searchMinDate"
                :allowMaxDate="maxData"
                @getDate="setSearchDate($event, 'end')"
              ></i-date-time-picker>
            </v-col>
          </v-row>
        </template>
        <template v-slot:body>
          <v-tabs active-class="active_tab" class="mt-3" :value="tab">
            <v-tab class="px-2" v-for="(item, index) in tabs" :key="item.tabpageId" @click="clickTab(item.tabpageId, index)">{{ item.title }}</v-tab>
            <v-tabs-items :value="tab" :touchless="true">
              <!--------------------------- 공사기간별 일반요금 내역 --------------------------->
              <v-tab-item>
                <PgNormalHistory ref="pgNormalHistory"></PgNormalHistory>
              </v-tab-item>
              <!--------------------------- 사업기간별 정액요금 내역 --------------------------->
              <v-tab-item>
                <PgBillingHistory ref="pgBillingHistory"></PgBillingHistory>
              </v-tab-item>
              <!--------------------------- 토스 카드결제 내역 --------------------------->
              <v-tab-item>
                <PgHistory ref="pgHistory"></PgHistory>
              </v-tab-item>
              <!--------------------------- 직접 계좌이체 내역 --------------------------->
              <v-tab-item>
                <AcHistory ref="acHistory"></AcHistory>
              </v-tab-item>
              <!--------------------------- 월별 정산 요약 --------------------------->
              <v-tab-item>
                <MonthlyHistory ref="monthlyHistory" :searchStartDate="searchStartDate" :searchEndDate="searchEndDate"></MonthlyHistory>
              </v-tab-item>
              <v-tab-item>
                <!--------------------------- 품목별 정산 요약 --------------------------->
                <ItemHistory ref="itemHistory"></ItemHistory>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </template>
      </i-card-vertical>
      <i-card-right
        :key="selectedTab"
        headerTitle
        :reportItems="reportItems"
        :useBtnList="selectedTab !== 'summary' ? ['btnSearch', 'btnPrint'] : ['btnSearch']"
        @btnSearch="btnSearch(true)"
        @btnPrint="btnPrint"
      ></i-card-right>
    </v-sheet>
  </v-container>
</template>
<script>
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import { getCurrentDate, getPreMonth } from '@/utils/common.js'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import PgNormalHistory from './PgNormalHistory.vue'
import PgBillingHistory from './PgBillingHistory.vue'
import PgHistory from './PgHistory.vue'
import AcHistory from './AcHistory.vue'
import ItemHistory from './ItemHistory.vue'
import MonthlyHistory from './MonthlyHistory.vue'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'settlementHistory',
  components: {
    IDateTimePicker,
    PgNormalHistory,
    PgBillingHistory,
    PgHistory,
    AcHistory,
    ItemHistory,
    MonthlyHistory,
  },
  data() {
    return {
      buttonUseList: [
        'btnSearch', // 조회
        'btnPrint', //출력
      ],
      reportItems: [
        { role: 'pdf', title: 'PDF' },
        { role: 'xls', title: 'EXCEL' },
      ],
      tabs: [
        { tabpageId: 'pgNormal', title: '공사기간별 일반결제 내역' },
        { tabpageId: 'pgBilling', title: '공사기간별 정액결제 내역' },
        { tabpageId: 'pg', title: '토스 카드결제 내역' },
        { tabpageId: 'ac', title: '직접 계좌이체 내역' },
        { tabpageId: 'summary', title: '월별 정산 요약' },
        { tabpageId: 'item', title: '품목별 정산 요약' },
      ],
      tab: 0, // 기존, 신규 탭 구분변수
      selectedTab: 'pgNormal', // 기존, 신규 탭 구분변수

      startDate: getPreMonth(3),
      endDate: getPreMonth(0),
      searchMinDate: getPreMonth(3),
      searchMaxDate: getPreMonth(0),
      searchStartDate: getPreMonth(3).replace(/[^0-9]/g, ''),
      searchEndDate: getPreMonth(0).replace(/[^0-9]/g, ''),
      maxData: getPreMonth(-1),
    }
  },
  computed: {},
  beforeMount() {},
  activated() {
    if (Object.keys(this.$route.params).length > 0) {
      // 대시보드에서 이동 시
      this.startDate = this.$route.params.searchStartDt
      this.endDate = this.$route.params.searchEndDt
      this.searchStartDate = this.$route.params.searchStartDt.replaceAll('-', '')
      this.searchEndDate = this.$route.params.searchEndDt.replaceAll('-', '')
      const index = this.tabs.findIndex((tab) => tab.tabpageId === this.$route.params.tab)
      if (index !== -1) {
        this.tab = index
        this.selectedTab = this.$route.params.tab
        this.btnSearch(true)
      }
    } else {
      this.btnSearch(true)
    }
  },
  mounted() {
    //this.btnSearch(true)
  },
  methods: {
    //------------------------------------------
    //  검색 년월일 포맷
    //------------------------------------------
    setSearchDate(e, div) {
      if (div === 'start') {
        this.searchMinDate = e
        this.searchStartDate = e.replace(/[^0-9]/g, '')
        this.startDate = e
      } else if (div === 'end') {
        this.searchMaxDate = e
        this.searchEndDate = e.replace(/[^0-9]/g, '')
        this.endDate = e
      }
      this.btnSearch(true)
    },

    async btnSearch(isNotify) {
      let params = {
        clntId: this.getClntId(),
        searchStartDate: this.searchStartDate.substring(0, 6),
        searchEndDate: this.searchEndDate.substring(0, 6),
      }
      // 토스 일반요금 정산 내역
      if (this.selectedTab === 'pgNormal') {
        setTimeout(() => {
          this.$refs.pgNormalHistory.btnSearch(params)
        }, 300)
      }
      // 토스 정액요금 정산 내역
      else if (this.selectedTab === 'pgBilling') {
        setTimeout(() => {
          this.$refs.pgBillingHistory.btnSearch(params)
        }, 300)
      } else if (this.selectedTab === 'pg') {
        setTimeout(() => {
          this.$refs.pgHistory.btnSearch(params)
        }, 300)
      } else if (this.selectedTab === 'ac') {
        // 직접 계좌이체 내역
        setTimeout(() => {
          this.$refs.acHistory.btnSearch(params)
        }, 300)
      } else if (this.selectedTab === 'summary') {
        setTimeout(() => {
          this.$refs.monthlyHistory.btnSearch(params)
        }, 300)
      } else if (this.selectedTab === 'item') {
        setTimeout(() => {
          this.$refs.itemHistory.btnSearch(params)
        }, 300)
      }
    },
    async btnPrint(type) {
      let title = this.tabs.find((el) => el.tabpageId === this.selectedTab).title
      let docTitle = `(${this.formatDate(this.searchStartDate).replaceAll('-', '.').substring(0, 7)} ~ ${this.formatDate(this.searchEndDate)
        .replaceAll('-', '.')
        .substring(0, 7)}).xlsx`
      let ref = null
      console.log('## this.selectedTab', this.selectedTab)
      switch (this.selectedTab) {
        case 'pgNormal':
          ref = this.$refs.pgNormalHistory
          break
        case 'pgBilling':
          ref = this.$refs.pgBillingHistory
          break
        case 'pg':
          ref = this.$refs.pgHistory
          break
        case 'ac':
          ref = this.$refs.acHistory
          break
        case 'item':
          ref = this.$refs.itemHistory
          break
      }
      if (ref) {
        ref.btnPrint(type, title, docTitle)
      }
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    formatToKoreanWon(value) {
      if (value) {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      } else return 0
    },
    formatDate(date, div = '.') {
      if (!date) return null

      if (date.indexOf(div) == -1) {
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${year}${div}${month}${div}${day}`
      } else if (date.indexOf(div) > -1) {
        const [year, month, day] = date.split(div)
        return `${year}${div}${month}${div}${day}`
      } else {
        return date
      }
    },
    clickTab(id, index) {
      if (this.selectedTab === id) return
      this.selectedTab = id
      this.tab = index
      this.btnSearch(false)
    },
    getCurrentMonth() {
      this.startDate = getCurrentDate()
      this.endDate = getCurrentDate()
      this.searchStartDate = getCurrentDate().replace(/[^0-9]/g, '')
      this.searchEndDate = getCurrentDate().replace(/[^0-9]/g, '')
      this.btnSearch(true)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/theme/variables.scss';
.outlined-btn {
  background-color: #fff;
  border-radius: 8px;
}
</style>
